import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BiCartAlt } from 'react-icons/bi';
import ReactGA from 'react-ga4';
import moment from 'moment';
import NothingHere from 'assets/vectors/NothingHere.svg';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import ButtonLink from 'components/ButtonLink';
import Dropdown from 'components/Dropdown';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { initializeCart } from 'store/cart';
import { setAlert } from 'store/error';
import { Test } from 'global/types';
import './index.css';

function Cart() {
    const [total, setTotal] = useState(0);

    const {
        isUpdatingCart,
        bundles,
    } = useAppSelector(state => state.cart);
    const dispatch = useAppDispatch();
    
    const numItems = bundles.length;

    const refreshCart = () => {
        axios.get('payments/cart/')
            .then(res => {
                // console.log(res.data);
                dispatch(initializeCart({
                    bundles: res.data?.cartBundles,
                }));

                // console.log(res.data.total);

                setTotal(res.data?.total);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
            });
    }

    const removeBundleFromCart = (bundleId: string) => {
        axios.post(`payments/cart/remove/bundle/${bundleId}/`)
        .then(res => {
            // console.log(res.data);
            refreshCart();

            // if (res.data.price > 0) {
            //     ReactGA.event('remove_from_cart', {
            //         currency: 'USD',
            //         value: res.data.price,
            //         items: [{
            //             item_id: bundleId,
            //             item_name: res.data.name
            //         }]
            //     });
            // }
        })
        .catch(error => {
            // console.log(error);
            dispatch(setAlert(error));
        });
    }

    useEffect(() => {
        refreshCart();
    }, []);

    if (isUpdatingCart) return <></>;

    return (
        <div className='layout'>
            <Helmet
                title='My Cart | PrepSharp Students'
            />
            <h1 className='cart__header'>
                <BiCartAlt className='cart__headerIcon' />
                My Cart
                {numItems > 0 && <span>
                    &nbsp;- {numItems} item{numItems > 1 ? 's' : ''} added
                </span>}
            </h1>
            <div className='cart'>
                {numItems === 0
                ?   <div className='cart__nothingHere'>
                        {/* <img className='cart__nothingHereVector' src={NothingHere} alt='Nothing here...' /> */}
                        {/* <p className='cart__nothingHereText'>
                            Nothing here yet...
                        </p> */}
                        <Link
                            className='cart__nothingHereLink'
                            to='/tests/digital-sat'
                            state={{ tab: 'Upgrade' }}
                        >
                            Select an upgrade option
                        </Link>
                    </div>  
                :   <div className='cart__items'>
                        {bundles.filter(bundle => bundle.tests?.length > 0).map(bundle => (
                            <div key={bundle.name} className='cart__cardItem'>
                                <div className='cart__cardItemHeader'>
                                    <h4 className='cart__cardItemName'>
                                        {bundle.name}
                                    </h4>
                                    {bundle.discount
                                    ?   <p className='cart__cardItemDiscount'>
                                            <span>${bundle.price.toFixed(2)}</span>
                                            ${bundle.discount.type === 'Percent'
                                                ? (bundle.price*(100 - bundle.discount.value)/100).toFixed(2)
                                                : bundle.discount.type === 'Amount'
                                                ? (bundle.price - bundle.discount.value).toFixed(2)
                                                : bundle.price.toFixed(2)
                                            }
                                        </p>
                                    :   <p className='cart__cardItemPrice'>
                                            ${bundle.price.toFixed(2)}
                                        </p>
                                    }
                                    <p
                                        className='cart__itemRemove'
                                        onClick={() => removeBundleFromCart(bundle.id)}
                                    >
                                        remove
                                    </p>
                                </div>
                                {bundle.description && <p className='cart__cardItemRow'>{bundle.description}</p>}
                                {/* {bundle.tests.map(test => (
                                    <p className='cart__cardItemRow' key={test}>
                                        {test}
                                    </p>
                                ))} */}
                            </div>
                        ))}
                        <div className='cart__cardTotal'>
                            <p>Your Total</p>
                            <b>${total.toFixed(2)}</b>
                        </div>
                        <ButtonLink 
                            className='cart__checkoutButton'
                            to='/checkout'
                        >
                            CHECKOUT
                        </ButtonLink>
                    </div>
                }
            </div>
        </div>
    );
}

export default Cart;